import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const SelectBillingCountryModalWrapper = styled.div`
  width: 600px;
  height: 400px;
  display: flex;
  flex-direction: column;
  padding: 48px;
  gap: 54px;

  background: ${colors.white};
  border-radius: 16px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .top-part {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    .text-container {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
    .select-container {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }

  .close-button {
    cursor: pointer;
    position: absolute;
    top: 24px;
    right: 24px;
  }
  .buttons-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: flex-end;
  }
`;
